import { each } from 'lodash';

const BarcodeParserPlugin = {
    install(Vue, options) {
        if (!options) {
            options = {};
        }

        Vue.prototype.$barcodeScanner.parseBarcode = function (barcode, callback) {
            console.log(String.fromCodePoint(0x1F522) + ' Scanned barcode: ', barcode);
            let barcode_patterns = [
                // USPS
                '^420[0-9]{5,9}]?(?<data>(92|93|94)[0-9]*)$', // USPS IMpb (used by Shippo, most recent spec (Pub 199))
                '^(?<data>[0-9]{22})$', // USPS Tracking (first 4 digits indicate method)
                '^(?<data>EA[0-9]{9}US)$', // Alt USPS Priority Mail Express

                // UPS
                '^(?<data>1Z[0-9A-Z]*)$', // Main UPS
                '^(?<data>T[0-9A-Z]*)$', // Alt UPS

                // FedEx
                '(?=^.{34}$)^[0-9]{20}01(?<data>[0-9]*[0-7])9*[0-9]$', // FedEx Express Label, short code format 8-11 digits (34 digit scan)
                '(?=^.{34}$)^[0-9]{20}00(?<data>[0-9]{12})$', // FedEx Express Label, 12 digit format (34 digit scan)
                '(?=^.{32}$)^[0-9]{16}(?<data>[0-9]{12})[0-9]{4}$', // FedEx Express Label, 12 digit format (32 digit scan)
                '(?=^.{34}$)^[0-9]{20}(?<data>[0-9]{14})$', // FedEx Express/Ground Label, 14 digit format (34 digit scan)
                '(?=^.{22}$)^96[0-9]{5}(?<data>[0-9]{15})$', // FedEx Ground Label, 15 digit format (22 digit scan)

                // Internal
                '^(?<data>[0-9]{0,6})$', // Order label (legacy)
                '^(?<context>C)(?<data>[0-9]*)$', // Customer Label
                '^(?<context>O)(?<data>[0-9]*)$', // Alt Order Label
                '^(?<context>R)(?<data>[0-9]*)$', // Order Label with Reverse Ship
                '^(?<context>I)(?<data>[0-9]*)$', // Inventory Label
                '^(?<context>SL)(?<data>[0-9]*)$', // Safe Location Label
                '^(?<context>B)(?<data>[0-9]*)$', // Bag Label

                // Security bags
                '^(?<context>G[A-Z]{1})([0-9]*)$', // Varies, but starts with 'G': GX1234567890

                // Unknown
                '^(?<data>[0-9]*)$', // Generic Numeric sequence
            ];
            let context = null;
            let data = null;
            let matched = false;

            each(barcode_patterns, barcode_pattern => {
                let matches = barcode.match(new RegExp(barcode_pattern));
                let originalContext = '';
                if (matches) {
                    // Get barcode context
                    if (matches.groups && matches.groups.context) {
                        context = matches.groups.context;

                        // Transform Security Bag barcode variations to a single generic context
                        if (context.length === 2 && context[0] === 'G') {
                            originalContext = context;
                            context = 'SB';
                        }
                    }

                    // Get barcode data
                    if (matches.groups && matches.groups.data)
                        data = matches.groups.data;
                    else {
                        data = matches.pop();
                    }

                    // Prepend Security Bag original context if exists, empty string if not
                    data = originalContext + data;

                    // Default to Order context if barcode is 6 digits or less
                    if (data.length <= 6 && context === null) {
                        context = 'O';
                    }
                    console.log(String.fromCodePoint(0x1F522) + ' Matched Barcode: ', data, 'Context: ', context, 'Pattern: ', barcode_pattern);
                    matched = true;
                    return false;
                }
            });

            // Return matched barcode, otherwise return raw data if no matches are found
            if (matched) {
                if (callback) {
                    callback(data, context);
                } else {
                    return data;
                }
            } else {
                data = barcode;
                if (callback) {
                    callback(data);
                } else {
                    return data;
                }
            }
        };

        Vue.prototype.$barcodeScanner.simulateBarcode = function (input) {
            let charArray = input.toString().split('');
            charArray.forEach(char => {
                window.dispatchEvent(new KeyboardEvent('keypress', {
                    'key': char
                }));
            });
        };

    }
};

export default BarcodeParserPlugin;
